import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the trending tab component.
 */
const useTrendingStyles = makeStyles()(() => ({
  trendingContainerRow: {
    display: 'flex',
    flex: '1',
    borderRadius: theme.borderRadius.m,
    boxShadow: theme.containerShadow,
    overflow: 'hidden',
    backgroundColor: theme.background.paper,
    justifyContent: 'center',
    maxWidth: '100%',
  },
  trendingContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundSize: '90px',
    backgroundPosition: '45px 10px',
    maxWidth: '100%',
  },
  trendContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'white',
    border: `1.5px solid ${colors.black}`,
    borderRadius: '10px',
    maxWidth: '80%',
    padding: '15px 15px 15px 15px',
  },
  trendingContent: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
  },
  trendingQA: {
    alignItems: 'start',
    maxWidth: '100%',
    maxHeight: '60px',
    overflow: 'scroll',
  },
  trendingNav: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  trendingNavButtonsContainer: {
    maxHeight: '30px',
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center',
  },
  trendingArrowButton: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  progressBarContainer: {
    display: 'flex',
    flex: '1',
    width: '100%',
    maxHeight: '5px',
    minHeight: '5px',
  },
  progressBar: {
    background: theme.primary.dark,
  },
  siteActivityContainerRow: {
    display: 'flex',
    flex: '1',
    borderRadius: theme.borderRadius.m,
    boxShadow: theme.containerShadow,
    overflow: 'hidden',
  },
  siteActivityContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
  horizontalPad: {
    height: '20px',
  },
  verticalPad: {
    width: '20px',
  },
}));

export default useTrendingStyles;
